@if (href(); as link) {
    <a
        class="btn btn-primary relative bg-gradient-primary h-[60px] py-4 px-14 font-bold text-[22px] text-deep-blue-900 leading-none transition-all duration-300 overflow-hidden hover:before:opacity-60 before:absolute before:inset-0 before:bg-deep-blue-50 before:opacity-0 before:transition-opacity before:duration-300 before:pointer-events-none"
        [href]="link"
        [attr.aria-label]="ariaLabel()"
    >
        <span class="relative z-10">{{ label() | translate }}</span>
    </a>
} @else {
    <button
        class="relative bg-gradient-primary h-[60px] py-4 px-14 font-bold text-[22px] text-deep-blue-900 leading-none transition-all duration-300 overflow-hidden hover:before:opacity-60 before:absolute before:inset-0 before:bg-deep-blue-50 before:opacity-0 before:transition-opacity before:duration-300 before:pointer-events-none"
        (click)="clicked.emit()"
        [attr.aria-label]="ariaLabel()"
    >
        <span class="relative z-10">{{ label() | translate }}</span>
    </button>
}
